export default (betKey) => {
  const splitKey = betKey.split(':')
  switch (true) {
    case splitKey[1] === 'AMOUNT':
      return `${splitKey[1]}:${splitKey[2]}`

    case splitKey.length === 2:
      return splitKey[1]

    default:
      return splitKey[2]
  }
}
